import { Injectable } from '@angular/core';
import { Comune } from '../model/model';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AssignStatiService {
  constructor() {
  }

  stati: any = [];
}
